import React from "react";
import RightHandSide from "../../Common/Services/RightHandSide";
import AboutInnBanContent from "../../Common/InnerBanner/AboutInnBanContent";
import { AboutInnerBanner } from "../../Common/InnerBanner/AboutInnerBanner";
import HeadContent from "../BlogContent/HeadContent";
import HeadDesign from "../BlogContent/HeadDesign";
import Info from "../BlogContent/Info";
import List from "../BlogContent/List";
import InfoContent from "../BlogContent/InfoContent";
import ListContent from "../BlogContent/ListContent";
import RecentBlogsList from "../BlogContent/RecentBlogsList";
import { Helmet } from "react-helmet";

const Blog32 = () => {
  const { image, heading, pageName } = AboutInnBanContent.BlogDetails;
  const { bg, para, date, blogHeading } = HeadContent.blog_32;

  const { title, p, pa} = InfoContent.Blog_32.one;
  const { title2, p2} = InfoContent.Blog_32.two;
  const { title3, p3 } = InfoContent.Blog_32.three;
  const { title4, p4} = InfoContent.Blog_32.four;
  const { title5, p5 } = InfoContent.Blog_32.five;
  const { title6, p6 } = InfoContent.Blog_32.six;
  const { Ctitle, Cp } = InfoContent.Blog_32.conclusion;
  const { title8, p8 } = InfoContent.Blog_32.eight;
  const { title9, p9 } = InfoContent.Blog_32.nine;
  const { title7, p7 } = InfoContent.Blog_32.seven;
  const { title10, p10 } = InfoContent.Blog_32.ten;


  const { liss1 } = ListContent.Blog_32.L1;
  const { liss2} = ListContent.Blog_32.L2;
  const { liss4 } = ListContent.Blog_32.L4;
  const { liss5 } = ListContent.Blog_32.L5;
  const { liss7 } = ListContent.Blog_32.L7;

  return (
    <>
      <Helmet>
        <title>Myths and Facts About Infertility Treatment (2026 Guide)</title>

        <meta
          name="description"
          content="Myths and facts about infertility treatment, explained by experts. Learn what's true, what's not, and find the best infertility specialist in Mumbai."
        />

        <meta
          name="keywords"
          content="Myths and Facts About Infertility Treatment, Best Infertility Specialist in Mumbai, IVF myths and facts, infertility treatment myths, infertility specialist Mumbai, IVF success rate myths, male infertility myths, infertility treatment cost India, fertility treatment misconceptions, IVF vs IUI myths"
        />

        <link
          rel="canonical"
          href="https://www.acmefertility.com/20/BlogDetails"
        />

        {/* Article Schema */}
        <script type="application/ld+json">
  {JSON.stringify({
    "@context": "https://schema.org",
    "@type": "Article",
    headline:
      "7 Reasons Dr. Neelam Bhise Is the Best Infertility Specialist in Mumbai for IVF Success in 2026",
    description:
      "Best infertility specialist in Mumbai — Dr. Neelam Bhise, 20+ yrs experience, PRP for failed IVF. Proven results. Book your consultation with Acme Fertility today.",
    author: {
      "@type": "Person",
      name: "Dr. Neelam Bhise",
      jobTitle: "Fertility Specialist and Endoscopic Surgeon",
      url: "https://www.acmefertility.com/Doctor",
    },
    publisher: {
      "@type": "Organization",
      name: "Acme Fertility",
      logo: {
        "@type": "ImageObject",
        url: "https://www.acmefertility.com/logo.png",
      },
    },
    datePublished: "2026-08-01",
    dateModified: "2026-08-01",
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id":
        "https://www.acmefertility.com/best-infertility-specialist-in-mumbai",
    },
    keywords:
      "best infertility specialist in mumbai, fertility specialist mumbai, IVF specialist mumbai, fertility doctor mumbai, infertility treatment mumbai, IVF centre mumbai, fertility clinic mumbai",
  })}
</script>

        {/* Author Schema */}
        <script type="application/ld+json">
  {JSON.stringify({
    "@context": "https://schema.org",
    "@type": "Person",
    name: "Dr. Neelam Bhise",
    jobTitle: "Fertility Specialist and Endoscopic Surgeon",
    worksFor: {
      "@type": "MedicalOrganization",
      name: "Acme Fertility",
      url: "https://www.acmefertility.com",
      address: {
        "@type": "PostalAddress",
        streetAddress: "402, Signature Business Park, Chembur",
        addressLocality: "Mumbai",
        addressCountry: "IN",
      },
      telephone: "+91 8655 00 6567",
    },
    alumniOf: [
      {
        "@type": "CollegeOrUniversity",
        name: "B.Y.L. Nair Tertiary Care Hospital, Mumbai",
      },
      {
        "@type": "CollegeOrUniversity",
        name: "National University Hospital, Singapore",
      },
    ],
    description:
      "Scientific Director of Acme Fertility, Reproductive Endocrinologist, and Endoscopic Surgeon with 20 years of overall clinical experience. Known for PRP therapy in repeated IVF failure cases and treatment of international fertility patients.",
    award: [
      "India's Most Promising and Emerging IVF Specialist Award (2017)",
      "50 Outstanding Women Healthcare Award 2017",
      "MOGS N.A. Purandare Award (2010)",
    ],
    knowsAbout: [
      "IVF",
      "ICSI",
      "IUI",
      "Infertility Treatment",
      "Reproductive Endocrinology",
      "Endoscopic Surgery",
      "PRP Therapy",
    ],
  })}
</script>

        {/* FAQ Schema */}
       <script type="application/ld+json">
  {JSON.stringify({
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "Who is considered the best infertility specialist in Mumbai?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "The best infertility specialist in Mumbai is typically one with ICMR-registered lab accreditation, verified success rate data, and a personalized approach to diagnosis and treatment.",
        },
      },
      {
        "@type": "Question",
        name: "How long does IVF treatment take from start to finish?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "A single IVF cycle usually takes four to six weeks, covering ovarian stimulation, egg retrieval, fertilization, and embryo transfer.",
        },
      },
      {
        "@type": "Question",
        name: "What is the difference between IUI, IVF, and ICSI?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "IUI places sperm directly into the uterus, IVF fertilizes eggs outside the body before transfer, and ICSI injects a single sperm into an egg for severe male-factor infertility.",
        },
      },
      {
        "@type": "Question",
        name: "How much does IVF cost in Mumbai?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "IVF costs vary based on medication dosage, protocol, and additional procedures like ICSI or genetic testing; a detailed, itemized quote should always be requested upfront.",
        },
      },
      {
        "@type": "Question",
        name: "What is a realistic IVF success rate by age?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Success rates are highest for women under 35, with national data showing a range of 45–60% per cycle, declining progressively as age increases.",
        },
      },
    ],
  })}
</script>
      </Helmet>

      <AboutInnerBanner image={image} heading={heading} pageName={pageName} />

      <div className="blog-area pt-100 pb-70">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <HeadDesign
                bg={bg}
                para={para}
                date={date}
                blogHeading={blogHeading}
              />
              <Info title={title} p={p} />
              <List liss={liss1} />
              <Info p={pa} />
               <Info title={title2} p={p2} />
              <List liss={liss2} />
              <Info title={title3} p={p3} />
              <Info title={title4} p={p4} />
              <List liss={liss4} />
              <Info title={title5} p={p5} />
              <List liss={liss5} />
              <Info title={title8} p={p8} />
              <Info title={title6} p={p6} />
              <Info title={Ctitle} p={Cp} />
              <Info title={title9} p={p9} />
              <Info title={title7} p={p7} />  
              <List liss={liss7} />   
              <Info title={title10} p={p10} />  

            </div>

            <div className="col-lg-4">
              <RecentBlogsList />
              <RightHandSide />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Blog32;
